import React from 'react'
import { Controller, FieldErrors, UseControllerOptions, UseFormMethods } from 'react-hook-form'

import TicketTextInput from '../TicketTextInput'
import * as Styled from './styled'

interface TicketFieldProps {
  name: string
  label: string
  rules?: UseControllerOptions['rules']
  errors?: FieldErrors
  control?: UseFormMethods['control']
  register?: UseFormMethods['register']
  onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  multiline?: boolean
  placeholder?: string
  className?: string
}

const TicketField: React.FC<TicketFieldProps> = ({
  name,
  label,
  rules,
  errors,
  control,
  register,
  multiline,
  placeholder,
  className,
}) => {
  const hasError = !!errors && errors[name]

  return (
    <Styled.TicketFieldRow>
      <Styled.TicketFieldLabel>{label}</Styled.TicketFieldLabel>
      {multiline ? (
        <Controller
          as={
            <Styled.TicketTextArea
              className={className}
              placeholder={placeholder}
              hasError={hasError}
            />
          }
          name={name}
          rules={rules}
          control={control}
        />
      ) : (
        <TicketTextInput
          className={className}
          hasError={hasError}
          name={name}
          register={register}
          placeholder={placeholder}
          type="text"
        />
      )}
    </Styled.TicketFieldRow>
  )
}

export default TicketField
